<template>
  <div v-if="options.length" class="abstract-version-picker is-flex is-align-items-center mb-2" dir="rtl" data-test="abstract-version-picker" @click.stop>
    <label class="is-size-7 has-text-weight-bold ml-2" for="abstract-version-select">גרסת תקציר:</label>
    <div class="select is-small">
      <select id="abstract-version-select" :value="value || ''" data-test="abstract-version-select" @change="onChange($event.target.value)">
        <option value="">התקציר שבעורך</option>
        <option v-for="o in options" :key="o.id" :value="String(o.id)">{{ o.label }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/custom/helpers/format_date'

const CHATBOT = ['chatbot', 'bot', 'system', 'ai']

function isChatbot (a) {
  return CHATBOT.includes(String(a.generated_by || '').toLowerCase())
}

function stamp (a) {
  const t = Date.parse(a.created_at)
  return isNaN(t) ? 0 : t
}

// VA2 - pick which stored abstract version goes out with the CV.
// Order: the recruiter's versions (newest first), then chatbot versions with
// their date. Emits `select` with the chosen row (or null for "the editor").
// Renders nothing when the list is empty or the endpoint is missing.
export function orderAbstracts (list) {
  const rows = (Array.isArray(list) ? list : []).filter(a => a && a.id && a.content)
  const byNewest = (a, b) => stamp(b) - stamp(a)
  return rows.filter(a => !isChatbot(a)).sort(byNewest).concat(rows.filter(isChatbot).sort(byNewest))
}

export default {
  name: 'AbstractVersionPicker',
  props: {
    applicantId: { type: Number, default: null },
    value: { type: [Number, String], default: null }
  },
  data () {
    return { abstracts: [] }
  },
  computed: {
    options () {
      return orderAbstracts(this.abstracts).map((a, i) => {
        const chatbot = isChatbot(a)
        const name = a.label_he || (chatbot ? 'צ׳אטבוט' : (i === 0 ? 'המגייסת (נוכחי)' : 'המגייסת'))
        const date = formatDate(a.created_at)
        const version = a.version ? ` v${a.version}` : ''
        return { id: a.id, label: `${name}${version}${date ? ' · ' + date : ''}`, row: a }
      })
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      if (!this.applicantId) return
      try {
        const res = await this.$network_utils.getApplicantAbstracts({ applicant_id: this.applicantId })
        this.abstracts = Array.isArray(res) ? res : ((res && res.abstracts) || [])
      } catch (e) {
        this.abstracts = []
      }
    },
    onChange (id) {
      const opt = this.options.find(o => String(o.id) === String(id))
      this.$emit('select', opt ? opt.row : null)
    }
  }
}
</script>
